/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ModificaBackButton } from './ModificaDatiComponent.styles';

function ModificaDatiComponent({ navigateBack }) {
  return (
    <div className="px-2 py-1 d-flex align-items-center">
      <ModificaBackButton type="button" onClick={() => navigateBack()}>
        <FontAwesomeIcon icon={faArrowLeftLong} />
        Modifica Preventivo
      </ModificaBackButton>
    </div>
  );
}

export default ModificaDatiComponent;
